import React, { useState,useEffect,useMemo } from 'react';
import {Box,Typography,Grid} from '@mui/material';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import DyDataGridCustom from '../../../../components/GlobalComponents/DYCustom1/DYCustom1';
import { useGetAlignmentMeetingDetailsByMeetingId,useGetAllAlignmentMeetingsByTenantId1 } from '../../Hooks/Index';
// import { ReactComponent as AddMeetingVector } from "../../AddMeetingSuccessVector.svg";
import{useNavigate} from 'react-router-dom';
import { NewUseStore } from '../../../../Store/newUseStore';
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
// import AlignmentCart from '../AlignmentCart/AlignmentCart';
// import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import AddAlignmentMeeting from '../Forms/AddMeeting/AddAlignmentMeeting';
import { useGetAllCooperate } from '../../../OKRManagment/Hooks';
// import MyMeetingCard from '../../../Meeting/MyMeetingCard/MyMeetingCard';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import AlignmentCart1 from '../AlignmentCart/AlignmentCart1';
import LoadingSpinner from '../../../../components/Progress/LoadingSpinner';

export const AllAlignmentRequest = ({periodId}:any) => {
    const updateNewCompanyId = NewUseStore((state) => state.updateNewCompanyId);
    // const[showDownloadLink,setShowDownlodLink]=useState<boolean>(false)
    const[meetId,setMeetId]=useState<any>('');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه

    const[showToastMessage,setShowToastMessage]=useState<boolean>(false);
    const[meetingAsyncState,setMeetingAsyncState]=useState<any|null>(null)
    // const [createTenantModal,setCreateTenantModal]=useState<boolean>(false);
    const navigate=useNavigate();
    const getDetSuccess = (data: any) => {
      if(data === undefined || data === null || 
        (data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos === null &&
        data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos === null)
      ){
        setMeetingAsyncState({
          isSuccess: false,
          metaData: { message: "درخواست یا پیشنهادی در جلسه مورد نظر وجود ندارد" },
        });
        setShowToastMessage(true);
      }
        else
      if (
        (data &&
          data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos &&
          data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos.length >
            0) ||
        (data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos &&
          data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos.length >
            0)
      ) {
        const id =
          data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos &&
          data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos.length > 0
            ? data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos[0].id
            : data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos[0].id;
        updateNewCompanyId(id);
        navigate("/alignmentCompanyTeams");
      } else {
        setMeetingAsyncState({
          isSuccess: false,
          metaData: { message: "اطلاعاتی برای نمایش وجود ندارد" },
        });
        setShowToastMessage(true);
      }
    };
    const getDetFailed=()=>{
  
    }
    // const {
    //     isLoading: meetLoadin,
    //     data: meetdata,
    //     isFetched,
    //     refetch: getAgain1,
    //   } = useGetAllMeetings({
    //     tenantId: profileTenantId,
    //     priodId: priodId,
    //     userPhoneNumber: userPhoneNumber,
    //   });
    const initialAddToTenantList=()=>{
      // let deleteBody={
      // ids:Ids}
      // deleteTeam(deleteBody)
      }

      const initialAddToMyList=()=>{
        // let deleteBody={
        // ids:Ids}
        // deleteTeam(deleteBody)
        }
    const profileTenantId=useSelector((state:any)=>state.meetings.profileTenantId);
    const{data:MeetDetData,isLoading:meetLoading,refetch:getAgain}
    =useGetAlignmentMeetingDetailsByMeetingId(getDetSuccess,getDetFailed,meetId);
   const {data:dataIndex,isLoading:dataLoading1,isError:dataError1}
   =useGetAllCooperate(periodId,profileTenantId);
    // const profileTenantId = NewUseStore((state) => state.newTenantId);

    // const priodId=useSelector((state:any)=>state.meetings.priodId);
    // const periodList=useSelector((state:any)=>state.meetings.periodList);
    // let priodId = useSelector((state: any) => state.meetings.priodId);
    // if (priodId === '' || priodId === null || priodId === undefined) {
    //   const x = periodList.filter((x : any)=>x.isCurrent === true);
    //   const xx = x[0]
    //   let {id} = xx;
    //   priodId=id;
    // }
    const userPhoneNumber:string=useSelector((state:any)=>state.loign.userPhoneNumber);
    const{isLoading:meetLoadin,data:meetdata,isFetched,refetch: getAgain1}
    =useGetAllAlignmentMeetingsByTenantId1({tenantId:profileTenantId,priodId:periodId,userPhoneNumber:userPhoneNumber})
    // const meetingsDataa=useSelector((state:any)=>state?.meetings?.meetingsList?.meetingsList);
    // const meetingLoadState=useSelector((state:any)=>state?.meetings?.meetingsList);
    const [existData,setExistData]=useState<any>(null);
    const [indexSelectionModel, setIndexSelectionModel] = useState<string | any>(
      localStorage.getItem("indexSelectionModel")
    );
    const [accessForReport,setAccessForReport]=useState<boolean>(false);
    const [krId, setKrId] = useState('');
    const [Ids, setIds] = useState(null);
    const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
    const [createTenantModal, setCreateTenantModal] = useState<boolean>(false);
    const [bank,setBank]=useState<boolean>(false);
    const [krRowData, setKrRowData] = useState(null);
    const[meetingLenght,setMeetingLenght]=useState<Number>(0);
    // const[reloadMeetingData,setReloadMeetingData]=useState<boolean>(false);
    const [showEditMeeting,setshowEditMeeting]=useState<boolean>(false);
    const [meetingId,setMeetingId]=useState<string|null>(null);
    
    useEffect(() => {
      if (meetdata) {
        let{accessibleForReport}=meetdata;
        setAccessForReport(accessibleForReport)
      }
    },[meetdata]);

    useEffect(() => {
      if (meetdata) {
        let{bank}=meetdata;
        setBank(bank)
      }
    },[meetdata]);

    useEffect(() => {
      console.log(meetingId);
    }, [meetingId]);
  
       useEffect(() => {
         if (meetdata) {
        //  let {meetingsList}=meetingLoadState;
        setExistData(meetdata.meetingsList)
        setMeetingLenght(meetdata.length)
         }
       }, [meetdata]);  
  
       const initialCreateMeeting=()=>{
        setCreateTenantModal(!createTenantModal)
       }
  
       const tenantsColumns: any = useMemo(()=>[
        {
          field: "rowid",
          headerName: "ردیف",
          width: 5,
          sortable: false,
          align:'center',
          headerAlign:'center',
          renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
        },
        // { field: 'personIds',
        //   align:'center',
        //   headerName: 'مسئول',
        //   headerAlign:'center',
        //   sortable:false,
        //   width:90,
        //   wrap:'wrap',
        //   // wrap:'wrap',
        //   // width: 320,
        //   //flex:1
        // },
        { field: 'description',
            align:'center',
            headerName: 'شرح پیشنهاد یا درخواست ',
            headerAlign:'center',
            sortable:false,
            wrap:'wrap',
             width:90,
             flex: 1,
        }
        ,
          { field: 'name',
          align:'center',
          headerName: 'نتیجه کلیدی',
          headerAlign:'center',
          sortable:false,
          wrap:'wrap',
          width:120,
          }
        ,
          
          { field: 'teamName',
          align:'center',
          headerName: 'تیم',
          headerAlign:'center',
          sortable:false,
          wrap:'wrap',
           width:90
          },
          { field: 'cooperateType',
            align:'center',
            headerName: 'نوع همکاری',
            headerAlign:'center',
            sortable:false,
            wrap:'wrap',
             width:90,
             renderCell: (par: any) => {
                  let lastValue: any = par?.row?.cooperateType;
                  return (
                    <Box 
                     bgcolor={lastValue === 'Request' ? "#D5f7D4" : '#bfd3f5 '}
                     sx={{ width: "100%", textAlign: "center",borderRadius:2 }}
                    >
                      {
                        lastValue === 'Request' ? 
                        <Typography
                    // color={lastValue >= lowerLimit && lastValue <= upperLimit ? "#125610" : '#993600 '}
                    fontSize={"0.8rem"}
                    color={ '#125610'} 
                  >
                    درخواست
                  </Typography> :
                  <Typography
                  // color={lastValue >= lowerLimit && lastValue <= upperLimit ? "#125610" : '#993600 '}
                  fontSize={"0.8rem"}
                  color={ 'blue'} 
                >
                  پیشنهاد
                </Typography>
                      }
                    </Box>
                  );
                },
          },
          { field: 'createBy',
            align:'center',
            headerName: 'پیشنهاد/درخواست دهنده',
            headerAlign:'center',
            sortable:false,
            wrap:'wrap',
             width:90
          }
          ,
          { field: 'personIds',
            align:'center',
            headerName: 'پیشنهاد/درخواست گیرنده',
            headerAlign:'center',
            sortable:false,
            wrap:'wrap',
             width:90
          }
        //   ,
        //   { field: 'okrState',
        //   align:'center',
        //   headerName: 'وضعیت',
        //   headerAlign:'center',
        //   sortable:false,
        //   wrap:'wrap',
        //   width:85,
        //   renderCell: (par: any) => {
        //     let value: string = par?.row?.okrState;
        //     switch (value) {
        //       case "فعال":
        //         return (
        //           <Box 
        //           bgcolor={"#D5f7D4"}
        //           sx={{ width: "100%", textAlign: "center",borderRadius:2 }}>
        //               <Typography
        //           color={"green"}
        //           fontSize={"0.8rem"}
        //         >
        //           {" "}
        //           {"فعال"}
        //         </Typography>
        //           </Box>
        //         );
        //         break;
    
        //       case "پیش نویس":
        //         return (
        //           <Box 
        //           bgcolor={"#bfd3f5"}
        //           sx={{ width: "100%", textAlign: "center" }}>
        //              <Typography
        //           color={"#3a82fc"}
        //           fontSize={"0.8rem"}
        //         >
        //           {" "}
        //           {"پیش نویس"}
        //         </Typography>
        //           </Box>
        //         );
        //         break;
    
        //       default:
        //         return null;
        //         break;
        //     }
        //   },
        //   }
        //   ,
        //   {
        //     field: 'startValue',
        //     headerName: 'شروع',
        //     width: 90,
        //     align: 'center',
        //     headerAlign: 'center',
        //     valueFormatter: (params: GridValueFormatterParams) => {
        //       const value = params.value as number; // گرفتن مقدار سلول
        //       // بررسی اینکه آیا مقدار منفی است یا خیر
        //       return value < 0 ? `${Math.abs(value)}-` : `${value}`; // نمایش عدد منفی در انتها
        //     },
        //   }
          //,
        //   { field: 'lastValueO',
        //   align:'center',
        //   headerName: 'آخرین مقدار',
        //   headerAlign:'center',
        //   sortable:false,
        //   wrap:'wrap',
        //    width:80,
        //    renderCell: (par: any) => {
        //     let lastValue: any = par?.row?.lastValueO;
        //     let lowerLimit: any = par?.row?.lowerLimitO;
        //     let upperLimit: any = par?.row?.upperLimitO;
        //     return (
        //       lastValue !== null && lastValue !== "" ?
        //       <Box 
        //       bgcolor={lastValue >= lowerLimit && lastValue <= upperLimit ? "#D5f7D4" : '#FFEEE5 '}
        //       sx={{ width: "100%", textAlign: "center",borderRadius:2 }}>
        //       <Typography
        //       color={lastValue >= lowerLimit && lastValue <= upperLimit ? "#125610" : '#993600 '}
        //       fontSize={"0.8rem"}
        //     >
        //       {lastValue}
        //     </Typography>
        //       </Box>:
        //       <Box>-</Box>
        //     );
        //   },
        //   }
          
          ,
          { field: 'status',
          align:'center',
          headerName: 'نظر نهایی گیرنده',
          headerAlign:'center',
          sortable:false,
          wrap:'wrap',
           width:90,
           renderCell: (par: any) => {
                let cooperateType: any = par?.row?.cooperateType;
                let toRequest: any = par?.row?.toRequest;
                let toOffer: any = par?.row?.toOffer;
                return (
                    cooperateType === 'Request' ?
                  <Box 
                  bgcolor={ 
                    cooperateType === "Request" && toRequest === 'توافق و اعمال'
                    ?'#D5f7D4' :
                    cooperateType === "Request" && toRequest === 'رد درخواست'
                    ? "#FFF8D0" :
                    cooperateType === "Request" && toRequest === 'عدم توافق' 
                    ? '#FFEEE5' :
                    cooperateType !== "Request" && toOffer === 'توافق و اعمال'
                    ?'#D5f7D4' :
                    cooperateType !== "Request" && toOffer === 'رد پیشنهاد'
                    ? "#FFF8D0" :
                    cooperateType !== "Request" && toOffer === 'عدم توافق' 
                    ? '#FFEEE5' : ''
                  } 
                  sx={{ width: "100%", textAlign: "center",borderRadius:2 }}>
                  <Typography
                  fontSize={"0.8rem"}
                  color={ 
                    cooperateType === "Request" && toRequest === 'توافق و اعمال'
                    ?'#125610' :
                    cooperateType === "Request" && toRequest === 'رد درخواست'
                    ? "#6B6440" :
                    cooperateType === "Request" && toRequest === 'عدم توافق' 
                    ? '#993600' :
                    cooperateType !== "Request" && toOffer === 'توافق و اعمال'
                    ?'#125610' :
                    cooperateType !== "Request" && toOffer === 'رد پیشنهاد'
                    ? "#6B6440" :
                    cooperateType !== "Request" && toOffer === 'عدم توافق' 
                    ? '#993600' : ''
                  } 
                >
                  {toRequest}
                </Typography>
                  </Box>:
                  <Box 
                  bgcolor={ 
                    cooperateType === "Request" && toRequest === 'توافق و اعمال'
                    ?'#D5f7D4' :
                    cooperateType === "Request" && toRequest === 'رد درخواست'
                    ? "#FFF8D0" :
                    cooperateType === "Request" && toRequest === 'عدم توافق' 
                    ? '#FFEEE5' :
                    cooperateType !== "Request" && toOffer === 'توافق و اعمال'
                    ?'#D5f7D4' :
                    cooperateType !== "Request" && toOffer === 'رد پیشنهاد'
                    ? "#FFF8D0" :
                    cooperateType !== "Request" && toOffer === 'عدم توافق' 
                    ? '#FFEEE5' : ''
                  } 
                  sx={{ width: "100%", textAlign: "center",borderRadius:2 }}>
                  <Typography
                  fontSize={"0.8rem"}
                  color={ 
                    cooperateType === "Request" && toRequest === 'توافق و اعمال'
                    ?'#125610' :
                    cooperateType === "Request" && toRequest === 'رد درخواست'
                    ? "#6B6440" :
                    cooperateType === "Request" && toRequest === 'عدم توافق' 
                    ? '#993600' :
                    cooperateType !== "Request" && toOffer === 'توافق و اعمال'
                    ?'#125610' :
                    cooperateType !== "Request" && toOffer === 'رد پیشنهاد'
                    ? "#6B6440" :
                    cooperateType !== "Request" && toOffer === 'عدم توافق' 
                    ? '#993600' : ''
                  } 
                >
                  {toOffer}
                </Typography>
                  </Box>
                );
              },
          }
          ,
          { field: 'meeting',
          align:'center',
          headerName: 'آخرین جلسه',
          headerAlign:'center',
          sortable:false,
          wrap:'wrap',
           width:90
          }
        //   ,
        //   { field: 'updateDate',
        //   align:'center',
        //   headerName: 'رسانی',
        //   headerAlign:'center',
        //   sortable:false,
        //   wrap:'wrap',
        //    width:105
        //   }
        //   ,
        //   { field: 'upperCount',
        //   align:'center',
        //   headerName: 'تعداد ارزیابی های بین حد بالا و پایین',
        //   headerAlign:'center',
        //   sortable:false,
        //   wrap:'wrap',
        //   width:105
        //   }
        //   ,
        //   { field: 'lowerCount',
        //   align:'center',
        //   headerName: 'تعداد ارزیابی های خارج از حد بالا و پایین',
        //   headerAlign:'center',
        //   sortable:false,
        //   wrap:'wrap',
        //   width:105
        //   }
        //   ,
        //   { field: 'count',
        //     align:'center',
        //     headerName: 'تعداد دفعات فاقد ارزیابی',
        //     headerAlign:'center',
        //     sortable:false,
        //     wrap:'wrap',
        //     width:105
        //     }
        //     ,
        //   {
        //     field: "comment",
        //     headerName: "نظرات",
        //     align: "center",
        //     headerAlign: "center",
        //     sortable: false,
        //     minWidth: 60,
        //     fontsize: "14px",
        //     renderCell: ( par : any) => {
        //       if(par !== undefined && par !== null){
        //       let idd: string = par?.row?.id;
        //       let namee: string = par?.row?.name;
        //       let commentCount: number = par?.row?.commentCount;
        //       return (
        //         <Box display={"flex"} justifyContent={"end"}>
        //         <CommentModal id={idd} name={namee} commentCount={commentCount}/>
        //         </Box>
        //     )
        //       }
        //     },
        //   },
        //   {
        //     field: "delete",
        //     headerName: "",
        //     align: "center",
        //     headerAlign: "center",
        //     sortable: false,
        //     maxWidth: 5,
        //     fontsize: "10px",
        //     renderCell: ( par : any) => {
        //       let idd: string = par?.row?.id;
        //       return (
        //         <Box display={"flex"} justifyContent={"center"}>
        //           {/* <Tooltip  title="ویرایش">
        //         <IconButton onClick={()=>{
        //               initialDelete(idd);
        //           }}   >
        //           <GridDeleteIcon />
        //         </IconButton>
        //       </Tooltip> */}
        //       <Button
        //             sx={{
        //               fontSize: "10px",
        //               marginRight: "5px",
        //               bgcolor: 'white',    // پس‌زمینه سفید
        //               color: 'red',    // متن قرمز
        //             }}
        //             variant="text"
        //             startIcon={<GridDeleteIcon />}
        //             onClick={() => {
        //               initialDelete(idd);
        //             }}
        //       >
        //       </Button>
        //      </Box>
        //       )
        //     },
        //   },
        //   {
        //     field: "edit",
        //     headerName: "",
        //     align: "center",
        //     headerAlign: "center",
        //     sortable: false,
        //     maxWidth: 5,
        //     fontsize: "10px",
        //     renderCell: ( par : any) => {
        //       let idd: string = par?.row?.id;
        //       return (
        //       <Box display={"flex"} justifyContent={"center"}>
        //       <Tooltip  title="ویرایش">
        //         <IconButton onClick={()=>{
        //               setHistoryModal(true);
        //               setKrId(idd);
        //           }}   >
        //           <EditIcon color='primary'   />
        //         </IconButton>
        //       </Tooltip>
        //       </Box>
        //       )
        //     },
        //   },
      ],[]);

       const renderContent=()=>{
    
        if (meetLoadin || dataLoading1) {
          return (<Box  width={'100%'} py={16}   >
            <LoadingSpinner   />
          </Box>)
        }
        // else if(appStatusCode === 7){
        //   return (<Box  width={'100%'} py={16}   >
        //      <Typography variant='body1' textAlign={'center'} fontSize={'20px'} fontWeight={700}>
        //      شما دسترسی به این قسمت را ندارید و باید لایسنس خود را ارتقا دهید
        // </Typography>
        //   </Box>)
        // }
        else {
        //   return <>
        //    <DyDataGridCustom
        //  rowHeight={10}
        //  data={dataLoading1 ? []: dataIndex}
        //  columns={tenantsColumns || []}
        //  hideFooter={false}
        // //  selectionModel={[]}
        // //  initialOnRowClick={()=>{}}
        //  additionalToolbar={true}
        //  setSelectionModel={() =>{}}
        //  setShowHistory={() =>{}}
        //  initialOnRowClick={/*setKrRowData*/() =>{}}
        //  setSpecialId={/*0setKrId*/() =>{}}
        //  initialDelete={() =>{}}
        //  setSelectedIds={/*setIds*/() =>{}}
        //  //initialAddToTenantList = {initialAddToTenantList}
        //  //initialAddToMyList={initialAddToMyList}
        //  /></>

         return <>
          <DyDataGridCustom
            rowHeight={10}
            data={dataLoading1 ? []: dataIndex}
            columns={tenantsColumns || []}
            hideFooter={false}
            //  selectionModel={[]}
            //  initialOnRowClick={()=>{}}
            additionalToolbar={false}
            setSelectionModel={setIndexSelectionModel}
            setShowHistory={() =>{}}
            initialOnRowClick={setKrRowData}
            setSpecialId={setKrId}
            initialDelete={() =>{}}
            setSelectedIds={setIds}
            initialAddToTenantList = {initialAddToTenantList}
            initialAddToMyList={initialAddToMyList}
        /></>
        }
      }

    if (meetLoadin || existData===null || isFetched!==true) {
      <Box width={"100%"} textAlign={"center"} py={5}>
      <LoadingSpinner />
    </Box>
    }
  
    return (
      <Grid container  spacing={1} >
        <Grid item xs={12}>
        <Box display={"flex"} flexDirection={"row-reverse"}>
        <Box display={"flex"} flexDirection={"row-reverse"} py={1} px={2}>
            {/* <DyButton
              caption={"ایجاد جلسه"}
              color={"#00l387C"}
              // onClick={loginHandler}
              disbled={false}
              variant={"contained"}
              bgColor={"#00387C"}
              onClick={initialCreateMeeting}
              // type={'submit'}
            /> */}
          </Box>
        </Box>
      </Grid>
     {
         existData && existData?.slice(0,1)?.map((data:any,i:number):any=>{
          return (
          <Grid item md={4} xs={12} key={i}>
            <Box
                key={i}
                >
            <AlignmentCart1
            setMeetId={setMeetId}
            info={data}
            prog={i}  
            accessForReport={accessForReport}
            bank={bank}
            // setShowDownlodLink={setShowDownlodLink}
            setPMeetingId={setMeetingId}
            setshowEditMeeting={setshowEditMeeting}
            showEditMeeting={showEditMeeting}
             />
            </Box> 
            </Grid>)
        })
     }
      {dataIndex?.length !==0 &&
         <Grid item xs={12}    >
         <Box display={'flex'}  flexDirection={'row-reverse'}>
        <Box width={'100%'}   >
        {
          renderContent()
        }
        </Box>
         </Box>
        </Grid>
       }
    {
      dataIndex?.length===0 && <Box sx={{ display: 'flex',alignItems:'center',justifyContent:'center',height:'100%',width:'100%' }}>
        <Grid item xs={12}>
         <div className="w-full flex justify-center">
          {/* <Box alignSelf={"center"} textAlign={"center"}> */}
          <Typography fontSize={20}>
            {/* <AddMeetingVector
              style={{
                width: "300px",
                height: "100%",
                alignSelf: "center",
                textAlign: "center",
              }}
              /> */}
                در این دوره زمانی درخواست/ پیشنهادی وجود ندارد
              </Typography>
              </div>
          {/* </Box> */}
        </Grid>
      
      </Box>
    } 
    
    {createTenantModal && (
        <ModalLyt
          title={"ایجاد جلسه"}
          height={700}
          width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
          showModal={Boolean(createTenantModal)}
          setShowModal={setCreateTenantModal}
        >
          {/* showToastMessage,setShowToastMessage */}
          <AddAlignmentMeeting
            // meetingLenght={meetingLenght}
            hideModal={setCreateTenantModal}
            setMeetingAsyncState={setMeetingAsyncState}
            setShowToastMessage2={setShowToastMessage2}
            profileTenantId={profileTenantId}
            onSuccess={getAgain1}
            onClose={setCreateTenantModal}
            // setReloadMeetingData={setReloadMeetingData}
          />
        </ModalLyt>
      )}

    {showToastMessage && (
        <DYToastMessage
          isSuccess={meetingAsyncState?.isSuccess}
          message={meetingAsyncState?.metaData.message}
          setShow={setShowToastMessage}
          show={showToastMessage}
        />
      )}
       {showToastMessage2 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage2}
            show={showToastMessage2}
          />
        )}
      </Grid>
    )
  }